// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__T+ikg","wave-squares":"styles_wave-squares__pCQ7m","wave-lines":"styles_wave-lines__kYTht"};